import React, { useEffect, useState,useRef } from 'react';
import { Container, Card, CardContent, TextField, Box ,Grid, Backdrop,Tabs, Tab,Dialog, DialogActions, DialogContent, DialogTitle, Typography,Button,CircularProgress,Input  } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import axios from 'axios';
import { BASE_URL } from '../../App';
import * as XLSX from 'xlsx';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper ,Switch, FormControlLabel} from '@mui/material';
import Swal from 'sweetalert2';
import { IconButton } from '@mui/material';
import { Edit, Visibility } from '@mui/icons-material';
import { ArrowForward } from '@mui/icons-material';
import { GetApp, ShoppingCart } from '@mui/icons-material';
import Loader from './Loader';
const MyCardWithAutocomplete = () => {
  const [chkupload, setchkupload] = useState([]);
const [isFileValid, setIsFileValid] = useState(true);
  const [showTable, setShowTable] = useState(false);
const [tableData, setTableData] = useState([]);
  const [excelData, setExcelData] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [open, setOpen] = React.useState(false);
    const [validData, setValidData] = useState([]);
    const [notValidData, setNotValidData] = useState([]);
    const login_id=localStorage.getItem("LOGIN_ID");
 const downloadExcelTemplate = () => {
   
    const templateData = [
      {
        "Dealer Code*": '',
         "Beneficiary ID*": '',
        
      },
    ];

    
    const ws = XLSX.utils.json_to_sheet(templateData);

    
    Object.keys(ws).forEach((key) => {
      if (key.includes('1')) {  
        ws[key].s = {
          fill: {
            fgColor: { rgb: "1E90FF" },
          },
          font: {
            bold: true, 
            color: { rgb: "FFFFFF" },
          },
          alignment: {
            horizontal: "center", 
            vertical: "center", 
          },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    });

    
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Template');

   
    XLSX.writeFile(wb, 'Beneficiary_ID.xlsx');
  };
  useEffect(() => {

  }, [showTable]);
  // useEffect(() => {

  // }, [validData]);
   const handleFileUpload = (e) => {
     
       
      setShowTable(false);  
      setchkupload(e.target.value);
      const file = e.target.files[0];
      const fileName = file?.name.toLowerCase();
    
      
      const regex = /\.xlsx|\.xls$/;
  
      if (regex.test(fileName)) {
        const xlsxFlag = fileName.indexOf(".xlsx") > 0;
    
        if (typeof FileReader !== "undefined") {
          const reader = new FileReader();
    
          reader.onload = (event) => {
            const data = event.target.result;
            let workbook;
    
            if (xlsxFlag) {
              workbook = XLSX.read(data, { type: 'array' });
            } else {
              workbook = XLSX.read(data, { type: 'binary' });
            }
    
            
            const sheetNames = workbook.SheetNames;
            let cnt = 0;
    
            sheetNames.forEach((sheetName) => {
              if (cnt === 0) {
               
                const sheet = workbook.Sheets[sheetName];
                const excelData = XLSX.utils.sheet_to_json(sheet, { defval: '' });
    
                if (excelData.length > 0) {
                  setExcelData(excelData);
                  setShowTable(true);
                }
                cnt++;
              }
            });
          };
    
          if (xlsxFlag) {
            reader.readAsArrayBuffer(file); // For .xlsx
          } else {
            reader.readAsBinaryString(file); // For .xls
          }
        } else {
          alert("Sorry! Your browser does not support HTML5!");
        }
      } else {
        // Handle invalid file type
        setIsFileValid(false);
        setShowTable(false);
      }
    };
    const handlesave = async () => {
      try {
        //alert('1');
        
        setOpen(true);
        const uploadapi = BASE_URL+'/getsolarcustomerdetailsaganistbeneficiary'
        const response = await axios.post(uploadapi, {login_id:login_id,solarcreation:excelData});
      //  alert('2');
        
        if (response.status === 200) {
          setOpen(false);
         
         // alert('3');
          
         if(response.data.status_code=="400")
         {
          //alert('4');
          setOpen(false);
             Swal.fire({
                    icon: 'info',
                    text: response.data.message,
                    confirmButtonText: 'Okay',
                  });
         }
         else if(response.data.status_code=="200")
          {
           // alert('5');
            setValidData(response.data.valid);
      setNotValidData(response.data.not_valid);
      setShowTable(false); 

      setchkupload([]); 
      setOpen(false); 
      // console.log('deepan',validData);


      setExcelData([]); 
     
          }
    
        }
      } catch (error) {
        alert('catch');
        setOpen(false);
        console.error('Error uploading data:', error);
        alert('Error uploading data');
      }
    };
    useEffect(() => {
    if (notValidData.length > 0) {
      //alert('6');
      Swal.fire({
        icon: 'info',
        title: 'INFO',
        //text: response?.data?.message, // Optional chaining to prevent errors if response or message is undefined
        html: `
          <p><strong>Not Valid Entries:</strong></p>
          <pre>${notValidData.join("\n")}</pre>
        `,
        confirmButtonText: 'Okay',
      });
    }
  }, [notValidData]);
    const handleordergen = async () => {
      try {
        
        setOpen(true);
        const uploadapi = BASE_URL+'/solarordercreation'
        const response = await axios.post(uploadapi, {login_id:login_id,ordercreation:validData});
        
        
        if (response.status === 200) {
          setOpen(false);
       
         if(response.data.status_code=="200")
          {
            setNotValidData([]);
            setValidData([]);
      setShowTable(false); 

      setchkupload([]); 
      setOpen(false); 

      Swal.fire({
        icon: 'success',
        text: response.data.message,
        confirmButtonText: 'Download',
      }).then(() => {
        
        setOpen(true);
       
        const errorData = response.data.error;

     
        const excelData = errorData.map(item => ({
            "BeneficiaryID": item.BeneficiaryID,
            "DOC_NO": item.DOC_NO,
            "SAP_DOCNO": item.SAP_DOCNO,
            "Errors": item.Errors
        }));
        
        const ExcelJS = require('exceljs');
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Sheet1');

         
          worksheet.columns = Object.keys(excelData[0]).map(key => ({ header: key, key }));

         
          excelData.forEach(data => worksheet.addRow(data));

         
          const headerRow = worksheet.getRow(1);
          headerRow.eachCell((cell) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'bf43bb' }
            };
            cell.font = {
              bold: true,             
              color: { argb: 'FFFFFF' }
            };
          });
         
          worksheet.autoFilter = {
              from: 'A1',
              to: 'I1'
          };
          setOpen(false);
         
          setTimeout(() => {
              workbook.xlsx.writeBuffer().then((buffer) => {
                  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                  const link = document.createElement('a');
                  link.href = window.URL.createObjectURL(blob);
                  link.download = 'Solar_Order_Creation_Response.xlsx';
                  link.click();
                 
              });
          }, 1000);

      });

      setExcelData([]); 
     
          }
          else if(response.data.status_code=="400"){
            setValidData([]);
            setNotValidData([]);
            setShowTable(false); 
      
            setchkupload([]); 
            setOpen(false); 
      
            Swal.fire({
              icon: 'info',
              text: response.data.message,
              confirmButtonText: 'Download',
            }).then(() => {
              
              setOpen(true);
             
              const errorData = response.data.error;
      
           
              const excelData = errorData.map(item => ({
                  "BeneficiaryID": item.BeneficiaryID,
                  "DOC_NO": item.DOC_NO,
                  "SAP_DOCNO": item.SAP_DOCNO,
                  "Errors": item.Errors
              }));
              
              const ExcelJS = require('exceljs');
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
      
               
                worksheet.columns = Object.keys(excelData[0]).map(key => ({ header: key, key }));
      
               
                excelData.forEach(data => worksheet.addRow(data));
      
               
                const headerRow = worksheet.getRow(1);
                headerRow.eachCell((cell) => {
                  cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'bf43bb' }
                  };
                  cell.font = {
                    bold: true,             
                    color: { argb: 'FFFFFF' }
                  };
                });
               
                worksheet.autoFilter = {
                    from: 'A1',
                    to: 'I1'
                };
                setOpen(false);
               
                setTimeout(() => {
                    workbook.xlsx.writeBuffer().then((buffer) => {
                        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Solar_Order_Creation_Response.xlsx';
                        link.click();
                       
                    });
                }, 1000);
      
            });
            
         
            setExcelData([]); 
           
          }
          
    
        }
        else{
          setNotValidData([]);
          setValidData([]);
          Swal.fire({
            icon: 'info',
            text: 'Please Generate Orders Again',
            //confirmButtonText: 'Download',
          })
        }
      } catch (error) {
        setOpen(false);
        setNotValidData([]);
        setValidData([]);
        setShowTable(false); 
        Swal.fire({
          icon: 'info',
          text: 'Please Regenerate Orders Again',
          //confirmButtonText: 'Download',
        })
        // console.error('Error uploading data:', error);
        // alert('Error uploading data');
      }
    };
  return (
    <Container maxWidth="lg" sx={{ paddingTop: '20px' }}>

      
       

       
        <Box >
            <Card sx={{ width: '100%', padding: '5px' }}>
            <CardContent>
            <Card >
            <CardContent>
     <Box
      display="flex"
      justifyContent="center" 
      alignItems="center"      
      gap={2}
      
    >
    
      <Input
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
        inputProps={{ accept: '.xlsx, .xls' }}
      //  ref={fileInputRef}
        value={chkupload}
      />

<Button  variant="contained"
        color="primary" 
        onClick={handlesave} disabled={!excelData.length}
        startIcon={<ShoppingCart />} 
        >
       GET ORDER DETAILS
      </Button>
      <Button
        variant="contained"
        color="success"
		
        startIcon={<GetApp />}  
        onClick={downloadExcelTemplate}
      >
        Download Template
      </Button>
    </Box>
    <br/>
    <br/>
    
    <Box
      display="flex"
      justifyContent="center" 
      alignItems="center"      
      gap={2}
      
    >
    
     
      <Button
      disabled={!validData.length}
        variant="contained"
        color="secondary"
        onClick={handleordergen}
        startIcon={<ArrowForward />}
      >
       GENERATE ORDER
      </Button>
    </Box>
    </CardContent>
    </Card>
    </CardContent>
    </Card>

   <br/>

        </Box>
    
       
        {showTable ? (
          
          excelData.length > 0 && (
            <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: 'auto' }}>
              <Table
                sx={{
                  borderCollapse: 'separate',
                  borderSpacing: '4px',
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '15px',
                }}
              >
                <TableHead
                  sx={{
                    position: 'sticky',
                    top: 0,
                    backgroundColor: '#61d1e5',
                    padding: '5px',
                    color: '#000',
                    zIndex: 1,
                  }}
                >
                  <TableRow>
                    {Object.keys(excelData[0]).map((key, index) => (
                      <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                        {key}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {excelData.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {Object.values(row).map((cell, cellIndex) => (
                        <TableCell key={cellIndex}>{cell}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        ) : (
          // Second table rendering with validData
          validData.length > 0 && (
            <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: 'auto' }}>
              <Table
                sx={{
                  borderCollapse: 'separate',
                  borderSpacing: '4px',
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '15px',
                }}
              >
                <TableHead
                  sx={{
                    position: 'sticky',
                    top: 0,
                    backgroundColor: '#61d1e5',
                    padding: '5px',
                    color: '#000',
                    zIndex: 1,
                  }}
                >
                  <TableRow>
                    {Object.keys(validData[0]).map((key, index) => (
                      <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                        {key}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {validData.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {Object.values(row).map((cell, cellIndex) => (
                        <TableCell key={cellIndex}>{cell}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        )}
 
    <br/>
   
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
            {/* <CircularProgress color="inherit" /> */}
            <Loader />
          </Backdrop>

    </Container>
  );
};

export default MyCardWithAutocomplete;


